import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';
import config from '../../../config';
import { getReviews } from '../../../services/bazaarvoice-api';
import ReviewItem from './ReviewItem';
import ReviewFilters from './ReviewFilter';
import ReviewIntro from './ReviewIntro';
import styles from './readreview-tw-styles';
import { Button } from '../Button';
import i18nMessages from '../../../constants/messages/pt-BR';

let sortFilterValue = i18nMessages.sortRatingdesc;
const ReadReview = observer(class ReadReview extends React.Component {
  static propTypes = {
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    store: PropTypes.oneOfType([PropTypes.object]).isRequired,
    locale: PropTypes.string.isRequired,
    readReviewPath: PropTypes.string,
    writePath: PropTypes.string,
    title: PropTypes.string,
    productPage: PropTypes.oneOfType([PropTypes.object]),
    pageContext: PropTypes.oneOfType([PropTypes.object]),
  };

  static defaultProps = {
    productId: '',
    readReviewPath: '',
    writePath: '',
    title: '',
    productPage: null,
    pageContext: null,
  };

  state = {
    reviewData: '',
    offset: 0,
  };
  componentDidMount() {
    const { locale, productId } = this.props;
    const { offset } = this.state;
    let preloadBVReviews = config.bazaarvoice[locale].preloadEnabled;
    let limit = config.bazaarvoice[locale].preloadConfig.numberOfReviews;
    if (!preloadBVReviews) {
      getReviews(productId, limit, offset, sortFilterValue, locale)
        .then(res => {
          if (res.data.Results.length > 0) {
            this.setState({
              reviewData: {
                Results: res.data.Results,
                TotalReviewCount: res.data.TotalResults,
              },
              offset: res.data.Offset,
            });
          }
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  }

  setSortFilterValue = sortFilterValue => {
    const { store, productId, locale } = this.props;
    store.onChangeSortFilter(sortFilterValue, productId, locale);
  };

  loadmoreReviews = () => {
    const { productId, locale } = this.props;
    let { reviewData, offset } = this.state;
    let limit = config.bazaarvoice[locale].preloadConfig.numberOfReviews;
    const newOffset = offset + limit;

    if (productId) {
      getReviews(productId, limit, newOffset, sortFilterValue, locale).then(
        response => {
          this.setState({
            reviewData: {
              Results: reviewData.Results.concat(response.data.Results),
              TotalReviewCount: response.data.TotalResults,
            },
            offset: response.data.Offset,
          });
        }
      );
    }
  };

  render() {
    let ratingData;
    const {
      store,
      readReviewPath,
      title,
      locale,
      writePath,
      productPage,
      pageContext,
    } = this.props;

    const { reviewData, offset } = this.state;
    if (store.ratingData !== null && store.reviewData !== null) {
      ratingData = store.ratingData;
    }
    return (
      <div>
        <div itemScope className={classNames(styles.reviewitem.rating_review)}>
          <div className={styles.readReviewMainDiv}>
            <ReviewIntro
              reviewCount={
                ratingData && ratingData.TotalReviewCount
                  ? ratingData.TotalReviewCount
                  : 0
              }
              maxRating={
                ratingData &&
                ratingData.ReviewStatistics &&
                ratingData.ReviewStatistics.OverallRatingRange
                  ? ratingData.ReviewStatistics.OverallRatingRange
                  : 0
              }
              avgRating={
                ratingData &&
                ratingData.ReviewStatistics &&
                ratingData.ReviewStatistics.AverageOverallRating
                  ? ratingData.ReviewStatistics.AverageOverallRating
                  : 0
              }
              readReviewPath={readReviewPath ? readReviewPath : null}
              title={title ? title : null}
            />

            <ReviewFilters
              filterData={ratingData}
              productData={productPage}
              pageContext={pageContext}
              writeReviewPath={writePath ? writePath : null}
              locale={locale}
              onSortFilterValueChange={this.setSortFilterValue}
              store={store}
            />
          </div>

          {ratingData && reviewData && (
            <React.Fragment>
              <ReviewItem
                itemData={
                  reviewData && reviewData.Results ? reviewData.Results : null
                }
                locale={locale}
                store={store}
              />
              {reviewData &&
              reviewData.TotalReviewCount - offset > store.limit ? (
                <div className={styles.loadmorereviews.wrapper}>
                  <Button
                    onClick={this.loadmoreReviews}
                    className={classNames(
                      styles.loadmorereviews.buyNowButton,
                      'event_product_review_view'
                    )}
                    data-action-detail="load-reviews"
                    aria-label="Carregar mais avaliações"
                  >
                    <FormattedMessage
                      id={i18nMessages.loadmore}
                      defaultMessage={i18nMessages.loadmore}
                    />
                  </Button>
                </div>
              ) : (
                ''
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
});

export default ReadReview;
